import {
  getAcceptanceCoefficientsReportEndpointProd,
  ACCEPTANCE_COEFFICIENTS_REPORT_DEV,
} from './urls';

export const getAcceptanceCoefficientsReportEndpoint = (): string =>
  process.env.NODE_ENV !== 'production'
    ? `/ns/sm/supply-manager${ACCEPTANCE_COEFFICIENTS_REPORT_DEV}`
    : getAcceptanceCoefficientsReportEndpointProd();
